<!--
입고스캔 > 트래킹정보 DB 갱신 컴포넌트
------------------------------------
-->
<template>
    <div>
        <div v-if="trackingDbInfo" class="db-info">
            * 트래킹정보 DB 갱신일 : {{ trackingDbInfo.refreshed_at }}
        </div>

        <!-- 화면블락 -->
        <div class="modal" :class="refreshState">
            <div class="msg" v-show="refreshState === 'loading'">
                <loading-icon class="uk-text-middle"></loading-icon>
                Tracking Database Loading...
            </div>

            <div class="msg" v-show="refreshState === 'fail'">
                It was fail with database job. <br />
                Refresh(F5) this page, please.
            </div>
        </div>
    </div>

</template>

<script>
    import LoadingIcon from "../../common/loading-icon";
    export default {
        components: {LoadingIcon},
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },


        },
        data: function () {
            return {
                /**
                 * (string) 상태
                 * - ready : 대기
                 * - loading : 처리중
                 * - fail : 실패
                 * - done : 완료
                 */
                refreshState: 'ready',

                /**
                 * (object)
                 * 트래킹정보 DB 갱신정보 (응답객체)
                 */
                trackingDbInfo: null,
            };
        },
        computed: {

        },

        mounted: function () {

        },

        methods: {
            /**
             * 입고스캔 트래킹정보 DB를 갱신한다.
             */
            refresh: function () {
                // 로딩중..
                this.refreshState = 'loading';

                // promise 생성
                let laod = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'post',
                        url: '/regions/' + this.regionId + '/ship-ins/refresh-tracking-db',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                laod.then((response) => {
                    // 완료
                    this.refreshState = 'done';
                    this.trackingDbInfo = response;
                    this.$emit('refreshed');
                }).catch(() => {
                    // 실패
                    this.refreshState = 'fail';
                });






            },

        },
    }
</script>

<style lang="scss" scoped>
    .db-info {
        font-size: 1.25rem;
        // color: #ee395b;
    }

    .modal {
        display:    none;
        position:   fixed;
        z-index:    1000;
        top:        0;
        left:       0;
        height:     100%;
        width:      100%;
        background: rgba( 0, 0, 0, .8 );

        &.loading, &.fail {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        &.fail {
            background: rgba( 190, 0, 0, .8);
        }

        .msg {
            color: #fff;
            font-size: 2rem;
        }
    }

</style>